import { HTMLAttributes } from 'react';

import classNames from 'classnames';

import styles from './styles.module.scss';

export const AccentFragment: React.FC<
  React.PropsWithChildren<HTMLAttributes<HTMLSpanElement>> & { type?: 'yellow' | 'blue' }
> = ({ type = 'blue', children, ...props }) => {
  return (
    <span {...props} className={classNames(styles.headingAccentFragment, props.className)} data-type={type}>
      {children}
    </span>
  );
};
